// extracted by mini-css-extract-plugin
module.exports = {"wrapped":"Group_wrapped__32WYu","overflowControl":"Group_overflowControl__Mft2e","normalIcon":"Group_normalIcon__2J6_p","errorText":"Group_errorText__2zQuW"};